import React, { useState, useEffect } from 'react';
import { auth, db, storage } from '../../utils/firebase';
import { doc, updateDoc, arrayUnion, arrayRemove, getDoc, setDoc } from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import HoverCard from './HoverCard.js';
import './DiningExperiences.css';

const DiningExperiences = () => {
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState({});
  const [kainanBalsaImage, setkainanBalsaImage] = useState(null); 
  const [sensyongsMuseumImage, setsensyongsMuseumImage] = useState(null); 
  const [bacoorEcoparkImage, setbacoorEcoparkImage] = useState(null); 
  const [funnImage, setfunnImage] = useState(null); 
  const [brickImage, setbrickImage] = useState(null); 
  const [cocinaImage, setcocinaImage] = useState(null); 

  useEffect(() => {

    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchFavorites(currentUser.uid);
      }
    });

 
    fetchImage('things/50OuxEK8wKFBBC1pmSGrX.jpg', setkainanBalsaImage);
    fetchImage('things/3fkTmR0GbEfQvnR4WnFnO.jpg', setsensyongsMuseumImage);
    fetchImage('things/5JTUGpz3xdPFXRFQbyfCp.jpg', setbacoorEcoparkImage);
    fetchImage('things/55e9MlgnBcIA5vkjM5f0m.jpg', setfunnImage);
    fetchImage('things/4W6qG0mBe7z5ly6YyUXoe.jpg', setbrickImage);
    fetchImage('things/4MnMkVXsCCUBdfsy18LWu.jpg', setcocinaImage);

    return unsubscribe;
  }, []);

  const fetchFavorites = async (userId) => {
    const userDocRef = doc(db, 'Users', userId);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      setFavorites(userDoc.data().favorites || {});
    } else {
      await setDoc(userDocRef, { favorites: {} });
      setFavorites({});
    }
  };

  const fetchImage = async (path, setImageCallback) => {
    try {
      const imageRef = ref(storage, path);
      const url = await getDownloadURL(imageRef);
      setImageCallback(url);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const toggleFavorite = async (event, itemTitle) => {
    event.stopPropagation(); // Prevent card click
    if (!user) return;

    const userDocRef = doc(db, 'Users', user.uid);
    const updatedFavorites = { ...favorites };

    const isFavorited = updatedFavorites['Dining and Culinary Experiences']?.includes(itemTitle);

    if (isFavorited) {
      updatedFavorites['Dining and Culinary Experiences'] = updatedFavorites['Dining and Culinary Experiences'].filter(
        (name) => name !== itemTitle
      );
      await updateDoc(userDocRef, { [`favorites.Dining and Culinary Experiences`]: arrayRemove(itemTitle) });
    } else {
      updatedFavorites['Dining and Culinary Experiences'] = [
        ...(updatedFavorites['Dining and Culinary Experiences'] || []),
        itemTitle,
      ];
      await updateDoc(userDocRef, { [`favorites.Dining and Culinary Experiences`]: arrayUnion(itemTitle) });
    }

    setFavorites(updatedFavorites);
  };

  return (
    <div className="cultural-experiences">
      <h1 className="main-title">Dining and Culinary Experiences</h1>
      <p className="description">
      Discover the local flavors of Bacoor with these must-visit dining spots.
      </p>
      <div className="card-container">
        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Kainan sa Balsa"
            imageUrl={kainanBalsaImage || 'placeholder-image.jpg'} 
            linkTo="/kainanbalsa"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes('Kainan sa Balsa')
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, 'Kainan sa Balsa')
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes('Kainan sa Balsa')
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="R. Antonio's"
            imageUrl={sensyongsMuseumImage || 'placeholder-image.jpg'} 
            linkTo="/rantonio"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes("R. Antonio's")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "R. Antonio's")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes("R. Antonio's")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Digman Halo-Halo"
            imageUrl={bacoorEcoparkImage || 'placeholder-image.jpg'} 
            linkTo="/digmanhalo"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes("Digman Halo-Halo")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Digman Halo-Halo")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes("Digman Halo-Halo")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Funnside Ningnangan Bacoor"
            imageUrl={funnImage || 'placeholder-image.jpg'} 
            linkTo="/funnside"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes("Funnside Ningnangan Bacoor")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Funnside Ningnangan Bacoor")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes("Funnside Ningnangan Bacoor")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>


        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Brick Wood PH"
            imageUrl={brickImage || 'placeholder-image.jpg'} 
            linkTo="/brickwood"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes("Brick Wood PH")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Brick Wood PH")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes("Brick Wood PH")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Cocina sa Garaje Gervasio"
            imageUrl={cocinaImage || 'placeholder-image.jpg'} 
            linkTo="/cocina"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Dining and Culinary Experiences']?.includes("Cocina sa Garaje Gervasio")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Cocina sa Garaje Gervasio")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Dining and Culinary Experiences']?.includes("Cocina sa Garaje Gervasio")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

export default DiningExperiences;
